import { EConditionType } from '../../../../json_query';
import { changeBuildingCondition } from '../../../state/advanced/building_condition';
import { getMultiSelectParam } from './abstract_params/multi_select_param';

export const BuildingCondition = getMultiSelectParam<EConditionType>(
  'Состояние',
  [
    { title: 'Типовой ремонт', value: EConditionType.RegularRepair },
    { title: 'Дизайнерский ремонт', value: EConditionType.DesignerRepair },
    { title: 'Под чистовую отделку', value: EConditionType.FullDecorationNeeded },
    { title: 'Требуется капитальный ремонт', value: EConditionType.MajorRepairNeeded },
    { title: 'Требуется коcметический ремонт', value: EConditionType.CosmeticRepairNeeded },
  ],
  'condition_type__free_appointment_object',
  changeBuildingCondition,
);
